export default {
  tab: {
    selectJob: 'Vybrať zákazku',
  },
};
